import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_cart_1: FaireProductEntity = {
  token: "atc_fs_cart_1",
  type: "product",
  name: "Girlfriend Socks",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/2221/3755/files/GF-GREY2.jpg?v=1757105877",
  priceDollars: 6.0,
  msrpDollars: 14.0,
  description: "ATC migration seed product",
  tags: ["apparel", "socks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
